module.exports = __webpack_public_path__ + "img/483.4d39c2f6.jpg";